// StockRatioVisualisation.js
import React, { useState, useEffect, useContext } from "react";
import { WatchlistContext } from "../contexts/StockWatchlistContext";
import DateFilterButtonsYear from "../components/DateFilterButtonsYear";

import "./StockVisualization.css";
import "../styles.css";
import RatioChart from "../components/charts/RatioChart";
import { fetchPublicFmpMetrics } from "../api";
import { StockRatioVisualizationContext } from "../contexts/StockRatioVisualizationContext";
import { METRIC_FIELDS } from "../constants/metricFields";

export default function StockRatioVisualisation() {
  const stockMap = {
    AAPL: "Apple",
    GOOGL: "Google",
    MSFT: "Microsoft",
    AMZN: "Amazon",
    TSLA: "Tesla",
    NVDA: "Nvidia"
  };

 
   const {
       ratioChartData,
       setRatioChartData,
       isRatioChartDataLoaded,
       setIsRatioChartDataLoaded,
       selectedStock,
       selectedPeriod,
       handleWatchlistStockChange,
       handlePeriodChange
     } = useContext(StockRatioVisualizationContext);
    
     const [loading, setLoading] = useState(!isRatioChartDataLoaded);

  const { symbols: watchlistStocks } = useContext(WatchlistContext);

  // Filter helper for ANNUAL metrics
  const filterDataByPeriod = (data, period) => {
    if (!Array.isArray(data) || data.length === 0 || period === 'MAX') return data;

    const yearsMap = { '1Y': 1, '2Y': 2, '3Y': 3, '4Y': 4, '5Y': 5 };
    const n = yearsMap[period];
    if (!n) return data;

    const desc = [...data].sort((a, b) => new Date(b.date) - new Date(a.date));
    return desc.slice(0, n).reverse();
  };
  
  useEffect(() => {
    setIsRatioChartDataLoaded(false);
  }, [selectedStock, setIsRatioChartDataLoaded]);

  useEffect(() => {

     if (isRatioChartDataLoaded) {
         setLoading(false);
         return;
       }

    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await fetchPublicFmpMetrics(selectedStock);
         
        const transformed = (Array.isArray(data) ? data : [])
        .map((item) => {
        const row = { date: item.date };
        METRIC_FIELDS.forEach(({ value }) => {
        row[value] = item[value];
        });
        return row;
        })
        .reverse();


      setRatioChartData(transformed);
     setIsRatioChartDataLoaded(true);

      } catch (e) {
        console.error(e);
        setRatioChartData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();

  }, [selectedStock, isRatioChartDataLoaded, setRatioChartData, setIsRatioChartDataLoaded]);


  return (
    <div className="App">
      <div className="main-container">
        <div className="content-area">
          <div className="visualization-selector-container">
            <h2>Stock Ratio Visualization</h2>
            <div className="stock-selector-container">
              <select
                className="watchlist-select"
                value=""
                onChange={handleWatchlistStockChange}
              >
                <option value="">From Watchlist</option>
                {watchlistStocks.map((ticker) => (
                  <option key={ticker} value={ticker}>
                    {stockMap[ticker] || ticker} ({ticker})
                  </option>
                ))}
              </select>

              <div className="date-filter-wrapper">
                <DateFilterButtonsYear
                  selectedPeriod={selectedPeriod}
                  onPeriodChange={handlePeriodChange}
                />
              </div>
            </div>
          </div>

          {loading ? (
            <p>Loading ratio data...</p>
          ) : (
            <div className="metrics-container">
              <div className="charts-container">
                <div className="chart-wrapper">
                  <RatioChart
                    chartData={filterDataByPeriod(ratioChartData, selectedPeriod)}
                    stockInfo={{
                      ticker: selectedStock,
                      name: stockMap[selectedStock] || selectedStock
                    }}
                    dataKey="priceToEarningsRatio"
                    label="P/E Ratio"
                  />
                </div>

                <div className="chart-wrapper">
                  <RatioChart
                    chartData={filterDataByPeriod(ratioChartData, selectedPeriod)}
                    stockInfo={{
                      ticker: selectedStock,
                      name: stockMap[selectedStock] || selectedStock
                    }}
                    dataKey="netProfitMargin"
                    label="Net Profit Margin"
                  />
                </div>

                <div className="chart-wrapper">
                  <RatioChart
                    chartData={filterDataByPeriod(ratioChartData, selectedPeriod)}
                    stockInfo={{
                      ticker: selectedStock,
                      name: stockMap[selectedStock] || selectedStock
                    }}
                    dataKey="debtToEquityRatio"
                    label="Debt to Equity Ratio"
                  />
                </div>

                <div className="chart-wrapper">
                  <RatioChart
                    chartData={filterDataByPeriod(ratioChartData, selectedPeriod)}
                    stockInfo={{
                      ticker: selectedStock,
                      name: stockMap[selectedStock] || selectedStock
                    }}
                    dataKey="freeCashFlowPerShare"
                    label="Free Cash Flow per Share"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

    </div>
  );
}
